import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Footer from '../index/Footer';
import Header from '../index/Header';

const styles = {
	paper: {
		margin: 20,
		marginTop: 30,
		padding: 10,
		height: 500
	},
	container: {
		textAlign: 'center'
	},
	formContainer: {
		display: 'flex',
		flexWrap: 'wrap'
	},
	textField: {
		marginLeft: '10px',
		marginRight: '10px',
		width: 200
	},
	red: {
		color: 'darkred',
		fontSize: '1.2em'
	},
	button: {
		marginLeft: '20px'
	}
};

const Logo = styled.img`
	max-height: 80px;
	margin-top: 50px;

	@media (max-width: 600px) {
		max-height: 70px;
		margin-top: 10px;
	}
`;

const LoginText = styled.p`
	color: #c655d6;
	margin-bottom: 24px;
	font-weight: bold;
	text-transform: uppercase;
	text-align: center;
	font-size: 18px;

	@media (max-width: 600px) {
		margin-bottom: 4px;
	}
`;

class ForgotPassword extends Component {
	constructor(props) {
		super(props);

		this.history = this.props.history;
	}

	state = {
		canSubmit: false,
		email: ''
	};

	componentDidMount() {
		document.title = 'Forgot Password | Chekkit';
	}

	componentWillUnmount() {
		document.body.className = document.body.className.replace(
			'red-background',
			''
		);
	}

	disableButton = () => {
		this.setState({ canSubmit: false });
	};

	enableButton = () => {
		this.setState({ canSubmit: true });
	};

	handleChange = (name) => (event) => {
		this.setState({
			[name]: event.target.value
		});

		if (event.target.value && this.state.email) {
			this.enableButton();
		} else {
			this.disableButton();
		}
	};

	submitEmailForPasswordReset = async () => {
		this.setState({ canSubmit: false });
		const { email } = this.state;

		const res = await axios.post('/api/forgot-password', { email });
		const { message } = res.data;

		this.setState({ message });
	};

	renderError = () => {
		if (this.state.message) {
			return `* ${this.state.message}`;
		}

		return '';
	};

	render() {
		return (
			<div>
				<Header />
				<Paper style={styles.paper}>
					<div className="container" style={styles.container}>
						<div className="row">
							<div className="col s12">
								<Logo src="/img/chekkit-logo.svg" />
								<LoginText>
									Enter your username (email) to reset
									password
								</LoginText>
								<div className="row" style={{ marginTop: 50 }}>
									<form
										className={styles.formContainer}
										noValidate
										autoComplete="off"
									>
										<TextField
											name="email"
											color="#c655d6"
											placeholder="Email"
											type="email"
											style={styles.textField}
											onChange={this.handleChange(
												'email'
											)}
										/>
										<Button
											style={styles.button}
											size="large"
											variant="contained"
											color="primary"
											disabled={!this.state.canSubmit}
											onClick={
												this.submitEmailForPasswordReset
											}
										>
											Reset
										</Button>
									</form>
									<p
										style={{
											...styles.container,
											...styles.red
										}}
									>
										{this.renderError()}
									</p>
								</div>
							</div>
						</div>
					</div>
				</Paper>
				<Footer />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		auth: state.auth,
		error: state.error
	};
}

export default connect(mapStateToProps, null)(withRouter(ForgotPassword));



// WEBPACK FOOTER //
// ./src/components/register/ForgotPassword.js